import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    MenuItem,
    Select,
    TextField,
    FormControlLabel,
    Checkbox,
    Button,
    CircularProgress
} from "@mui/material";
import { useEffect, useState } from "react";
import Api, { postApi } from "../Api";
import * as React from "react";
import { useSelector } from "react-redux";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import {styled} from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Blacklist = () => {
    const [lists, setLists] = useState( []);
    const [activeList, setActiveList] = useState(1);
    const [activeStatus, setActiveStatus] = useState(1); // 1 - активные, 0 - архив
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [steamid, setSteamId] = useState('');
    const [nickname, setNickname] = useState('');
    const [reason, setReason] = useState('');
    const [comments, setComments] = useState('');
    const [addinlists, setAddInLists] = useState([]);
    const [removeItem, setRemoveItem] = useState({});
    const [archiveItem, setArchiveItem] = useState({});
    const permissions = useSelector(state => state.permissions.value);

    const getData = async () => {
        setLoading(true);
        try {
            setItems(await Api(`admin/blacklist/get-list/${activeList}/${activeStatus}`));
            setLists(await Api(`admin/blacklist/get-type`));
        } catch (error) {
            console.error("Ошибка при загрузке данных:", error);
        } finally {
            setLoading(false);
        }
    };

    const addInList = async () => {
        try {
            await postApi('admin/blacklist/add', {
                nickname: nickname,
                steam: steamid,
                reason: reason,
                comments: comments,
                type: addinlists
            });
            setAddOpen(false);
            setSteamId('');
            setNickname('');
            setReason('');
            setComments('');
            setAddInLists([]);
            getData();
        } catch (error) {
            console.error("Ошибка при добавлении в ЧС:", error);
        }
    };

    const removeFromList = async () => {
        try {
            await postApi(`admin/blacklist/delete/${removeItem.id}`);
            setRemoveItem({});
            getData();
        } catch (error) {
            console.error("Ошибка при удалении из ЧС:", error);
        }
    };

    const archiveRecord = async () => {
        try {
            await postApi(`admin/blacklist/delete/${archiveItem.id}`);
            setArchiveItem({});
            getData();
        } catch (error) {
            console.error("Ошибка при архивации:", error);
        }
    };

    useEffect(() => {
        getData();
    }, [activeList, activeStatus]);

    return (
        <div>
            <Paper sx={{ width: '100%', overflow: 'auto' }}>
                <Box sx={{ display: 'flex', width: '100%' }} component={'div'}>
                    <Box sx={{ marginLeft: 2, flexGrow: 1, display: { md: 'flex' } }}>
                        <Typography variant={'h5'} sx={{ p: 2 }}>Управление черным списком</Typography>
                    </Box>
                    <Box sx={{ flexGrow: 10, p: 2, display: 'flex', alignItems: 'center' }}>
                        <Select
                            size={'small'}
                            value={activeList}
                            onChange={(e) => { setActiveList(e.target.value) }}
                            sx={{ width: '400px', mr: 2 }}
                        >
                            {lists.map((i, e) => <MenuItem key={'list_' + e} value={i.id}>{i.full_name}</MenuItem>)}
                        </Select>
                        <Select
                            size={'small'}
                            value={activeStatus}
                            onChange={(e) => setActiveStatus(e.target.value)}
                            sx={{ width: '200px', mr: 2 }}
                        >
                            <MenuItem value={1}>Активные</MenuItem>
                            <MenuItem value={0}>Архив</MenuItem>
                        </Select>
                        {permissions.includes('add_blacklist') &&
                            <Box sx={{ flexGrow: 0 }}>
                                <Button variant={'contained'} color={'warning'} onClick={() => { setAddOpen(true) }}>ДОБАВИТЬ</Button>
                            </Box>
                        }
                    </Box>
                </Box>
            </Paper>

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                    <CircularProgress />
                </Box>
            ) : permissions.includes('view_blacklist') ? (
                <Paper sx={{ width: '100%', overflow: 'auto', mt: 1 }}>
                    <TableContainer>
                        <Table stickyHeader aria-label="sticky table" size={"small"}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>#п/п</TableCell>
                                    <TableCell>Никнейм</TableCell>
                                    <TableCell>SteamID64</TableCell>
                                    <TableCell>Причина</TableCell>
                                    {permissions.includes('view_ca_comments') && <TableCell>Комментарий ГА</TableCell>}
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.map((i, e) => (
                                    <StyledTableRow key={`bl_item_${e}`}>
                                        <TableCell>{i.id}</TableCell>
                                        <TableCell>{i.nickname}</TableCell>
                                        <TableCell>{i.steam_id64}</TableCell>
                                        <TableCell>{i.reason}</TableCell>
                                        {permissions.includes('view_ca_comments') && <TableCell>{i.comments}</TableCell>}
                                        <TableCell>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                {activeStatus === 1 ? (
                                                    permissions.includes('delete_blacklist') && (
                                                        <>
                                                            <Button
                                                                variant={'outlined'}
                                                                color={'success'}
                                                                startIcon={<LockOpenIcon />}
                                                                onClick={() => { setRemoveItem(i) }}
                                                            >
                                                                Разблокировать
                                                            </Button>
                                                        </>
                                                    )
                                                ) : (
                                                    permissions.includes('delete_blacklist') && (
                                                        <p>Удалить  из архива нельзя </p>
                                                    )
                                                )}
                                            </Box>
                                        </TableCell>
                                </StyledTableRow>
                        ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            ) : (
                <Paper sx={{ width: '100%', mt: 1, p: 1 }}>
                    <Typography color={'error'}>У вас нет права просмотра черного списка</Typography>
                </Paper>
            )}

            {permissions.includes('add_blacklist') && (
                <Dialog
                    open={addOpen}
                    onClose={() => { setAddOpen(false) }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Добавление игрока в Черный Список"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText component={'span'} id="alert-dialog-description">
                            <TextField
                                fullWidth
                                value={steamid}
                                placeholder="STEAMID64 (длинное число)"
                                onChange={(e) => { setSteamId(e.target.value) }}
                                sx={{ mb: 2 }}
                            />
                            <TextField
                                fullWidth
                                value={nickname}
                                placeholder="Никнейм"
                                onChange={(e) => { setNickname(e.target.value) }}
                                sx={{ mb: 2 }}
                            />
                            <TextField
                                fullWidth
                                value={reason}
                                placeholder="Причина для внесения"
                                onChange={(e) => { setReason(e.target.value) }}
                                sx={{ mb: 2 }}
                            />
                             <TextField
                                fullWidth
                                value={comments}
                                placeholder="Комментарий ГА"
                                onChange={(e) => { setComments(e.target.value) }}
                                sx={{ mb: 2 }}
                            />
                            {lists.map((i, e) => (
                                <FormControlLabel
                                    key={'listbox_' + e}
                                    label={i.short_name}
                                    control={
                                        <Checkbox
                                            checked={addinlists.indexOf(i.id) > -1}
                                            onChange={(e) => {
                                                let al = [...addinlists];
                                                if (e.target.checked) {
                                                    al.push(i.id);
                                                } else {
                                                    al = al.filter(id => id !== i.id);
                                                }
                                                setAddInLists(al);
                                            }}
                                        />
                                    }
                                />
                            ))}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAddOpen(false) }} color={'info'} variant={'contained'} autoFocus>
                            Отмена
                        </Button>
                        <Button onClick={addInList} color={'error'} variant={'contained'}>
                            Внести
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            {permissions.includes('delete_blacklist') && (
                <>
                    <Dialog
                        open={removeItem.hasOwnProperty('id')}
                        onClose={() => { setRemoveItem({}) }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Вынесение игрока из ЧС"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText component={'span'} id="alert-dialog-description">
                                Действительно разблокировать <Typography component={'span'} color={'yellow'}>{removeItem.nickname}</Typography>?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => { setRemoveItem({}) }} color={'info'} variant={'contained'} autoFocus>
                                Отмена
                            </Button>
                            <Button onClick={removeFromList} color={'error'} variant={'contained'}>
                                Да
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={archiveItem.hasOwnProperty('id')}
                        onClose={() => { setArchiveItem({}) }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Отправка в архив"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText component={'span'} id="alert-dialog-description">
                                Действительно отправить <Typography component={'span'} color={'yellow'}>{archiveItem.nickname}</Typography> в архив?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => { setArchiveItem({}) }} color={'info'} variant={'contained'} autoFocus>
                                Отмена
                            </Button>
                            <Button onClick={archiveRecord} color={'secondary'} variant={'contained'}>
                                В архив
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            )}
        </div>
    );
};

export default Blacklist;